import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { CurrencyModel } from '../../models/currency-model';
import { AuthService, AuthType } from '../../../../shared/services/auth.service';
import { map, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageCurrenciesService {
  public currencies: CurrencyModel[] = [];
  private _forceUpdate = false;
  constructor(private http: HttpClient, private _authService: AuthService) { }

  updateCurrencies(Currencies: CurrencyModel[]): Observable<any> {
    this._forceUpdate = true;
    return this.http.put<any>('/currency', Currencies, this._authService.espOptions);
  }

  getCurrencies(): Observable<HttpResponse<CurrencyModel[]>> {
    return this.http.get<CurrencyModel[]>('/currency', { observe: 'response', headers: this._authService.buildAuthHeader(AuthType.ESP) }).pipe(
      tap(resp => {
        this._cachedCurrencies = resp.body || [];
        this.currencies = resp.body;
      })
    );
  }

  private _cachedCurrencies: CurrencyModel[] = [];
  getCachedCurrencies(): Observable<CurrencyModel[]> {
    if (this._cachedCurrencies.length == 0 || this._forceUpdate) {
      return this.getCurrencies().pipe(
        map(resp => {
          this._cachedCurrencies = resp.body;
          this.currencies = resp.body;
          this._forceUpdate = false;
          return this._cachedCurrencies;
        })
      )
    } else {
      return of(this._cachedCurrencies);
    }
  }

/**
 * Takes comma separated currencies specially from allowedValuesCriteria in custom field object
 * @returns CurrencyModel[]
 */
  getAllowedCurrencies(allowedCurrencies: string): CurrencyModel[] {
    const allowedValuesCriteriaArray = allowedCurrencies.split(',');
    return this.currencies.filter(c => allowedValuesCriteriaArray.includes(c.id.toString()))
  }
}

